import MenuStrictVue from './controllers/menu-strict-vue';
import MenuTreeVue from './controllers/menu-tree-vue';

window.application.register('menu-strict-vue', MenuStrictVue);
window.application.register('menu-tree-vue', MenuTreeVue);
